
import { defineComponent } from "vue";
import { IJbaRiskSummary, IJbaScoreCount } from "@/types";
import { useGammaWebServices } from "@/services";

export default defineComponent({
  name: "PrintFloodDetails",
  computed: {
    JBAScores(): IJbaScoreCount[] | undefined {
      return (
        useGammaWebServices().selectedRisk?.data?.RiskSummary as
          | IJbaRiskSummary
          | undefined
      )?.JBAScoreCount;
    },
  },
});
